/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DashboardGoals {
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;

    /**
     * Method should return the month/date formatted by locale from culture settings string. No year should be included
     */
    const getFormattedDate = (dateFilter: any, date: Date): string => {
        const res: string = dateFilter(date, 'shortDate').replace(/\d{4}/, ''); // remove the year, we don't need it
        const divider = res.split(/\d/).filter(ch => !!ch)[0]; // detect the divider for the current locale

        return res
            .split(divider)
            .filter(ch => !!ch)
            .slice(0, 2)
            .join(divider);
    }

    function goalsDateRangeVerbose(
        $filter: any,
        busInfoService: BusinessInfoDataService,
        $translate: ng.translate.ITranslateService
    ): any {
        const thisWeekStart = busInfoService.startOfTheWeekMoment;
        const thisWeekEnd = busInfoService.endOfTheWeekMoment;
        const lastWeekEnd = busInfoService.endOfTheLastWeekMoment
        const lastWeekStart = busInfoService.startOfTheLastWeekMoment
        const dateFilter = $filter('date');

        return (dateRange: GoalDateRangeEnum) => {
            switch (dateRange) {
                case GoalDateRangeEnum.Today:
                    return 'LABEL_TODAY';
                case GoalDateRangeEnum.Yesterday:
                    return 'LABEL_YESTERDAY';
                case GoalDateRangeEnum.Tomorrow:
                    return 'LABEL_TOMORROW';
                case GoalDateRangeEnum.ThisWeek:
                    return $translate.instant('LABEL_DASHBOARD_THIS_WEEK', {
                        weekDateRange: `${getFormattedDate(dateFilter, thisWeekStart.toDate())} - ${getFormattedDate(dateFilter, thisWeekEnd.toDate())}`
                    });
                case GoalDateRangeEnum.LastWeek:
                    return $translate.instant('LABEL_DASHBOARD_LAST_WEEK', {
                        weekDateRange: `${getFormattedDate(dateFilter, lastWeekStart.toDate())} - ${getFormattedDate(dateFilter, lastWeekEnd.toDate())}`
                    });
                case GoalDateRangeEnum.ThisMonth:
                    return 'LABEL_THIS_MONTH';
                case GoalDateRangeEnum.LastMonth:
                    return 'LABEL_LAST_MONTH';
                case GoalDateRangeEnum.NextMonth:
                    return 'LABEL_NEXT_MONTH';
                case GoalDateRangeEnum.LastTwelveMonths:
                    return 'LABEL_LAST_TWELVE_MONTHS';
                case GoalDateRangeEnum.YearToDate:
                    return 'LABEL_YTD';
                case GoalDateRangeEnum.SpecificYear:
                    return 'LABEL_SELECTED_YEAR';
                default:
                    return '';
            }
        }
    }

    goalsDateRangeVerbose.$inject = [
        '$filter',
        'meevo.components.common.BusinessInfoDataService',
        '$translate'
    ];

    angular.module('meevo.plugins.dashboardGoals')
        .filter('goalsDateRangeVerbose', goalsDateRangeVerbose);
}
